const accessTypes = {
  READ: 1,
  WRITE: 2,
}

const infoTypes = {
}

const state = {
  namespaced: true,
  accessTypes,
  infoTypes,
  entities: [],
  roles: [],
  userRoles: [],
  userPermissions: [],
  serviceIdentifier: '',
}

const getters = {
  entities: state => state.entities,
  serviceIdentifier: state => state.serviceIdentifier,
}

const actions = {
}

const mutations = {
}

export default {
  state () {
    return state
  },
  mutations,
  getters,
  actions,
}
